import React from 'react';
import { Popover, Button, Typography } from '@material-ui/core';

interface DeclineDialogProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onConfirm: () => void;
}

const DeclineDialog: React.FC<DeclineDialogProps> = ({ anchorEl, onClose, onConfirm }) => {
  const open = Boolean(anchorEl);

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      PaperProps={{
        style: {
          width: 231,
          height: 199,
          backgroundColor: '#FFFFFF',
          borderRadius: 20,
          border: '1px solid #D1D5DB',
          marginLeft: '60px',
        },
      }}
    >
      <div style={{ padding: 16, textAlign: 'center', minWidth: 250, alignItems: 'center' }}>
        <Typography
          style={{
            fontSize: 16,
            fontWeight: '400',
            textAlign: 'center',
            maxWidth: 190, 
            whiteSpace: 'normal',
            wordBreak: 'normal',
            lineHeight: '1.5',
            color: '#304497',
          }}
        >
          Are you sure that you want to decline the transaction?
        </Typography>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 10,
            marginTop: 20,
          }}
        >
          <Button
            style={{
              color: '#DC1F1F',
              borderRadius: 12,
              width: 100,
              height: 35,
              fontSize: 16,
            }}
            onClick={onConfirm}
          >
            Decline
          </Button>

          <Button
            style={{
              color: '#304497',
              borderRadius: 20,
              width: 100,
              height: 35,
              fontSize: 16,
            }}
            onClick={onClose}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Popover>
  );
};

export default DeclineDialog;
